module.exports = ".btn-group .btn{\r\n    min-width: 5px;\r\n}\r\n.btn-group i{  \r\n    color: white;\r\n}\r\n.small-icon img{\r\n    width: 30px;\r\n    cursor: pointer;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/lead/assign-leads/assign-lead-grid/assign-lead-grid.component.css
// module id = ./src/app/Pages/lead/assign-leads/assign-lead-grid/assign-lead-grid.component.css
// module chunks = main